// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1233":"a43d5435","6740":"3c0e75b0","8582":"89208c94"}[chunkId] + ".chunk.css";
};